export const darkToggle = `
  <button id="dark-toggle" class="dark-toggle">
    <div class="dark-toggle__wrapper">
      <div class="dark-toggle__part-wrapper dark-toggle__ears-wrapper">
        <div class="dark-toggle__part-wrapper dark-toggle__even-ears-wrapper">
          <div class="dark-toggle__part-wrapper dark-toggle__ear-wrapper dark-toggle__ear-wrapper--0">
            <div class="dark-toggle__rabbit-ear dark-toggle__rabbit-ear--0"></div>
          </div>
          <div class="dark-toggle__part-wrapper dark-toggle__ear-wrapper dark-toggle__ear-wrapper--2">
            <div class="dark-toggle__rabbit-ear-sub dark-toggle__rabbit-ear--2"></div>
          </div>
          <div class="dark-toggle__part-wrapper dark-toggle__ear-wrapper dark-toggle__ear-wrapper--4">
            <div class="dark-toggle__rabbit-ear-sub dark-toggle__rabbit-ear--4"></div>
          </div>
          <div class="dark-toggle__part-wrapper dark-toggle__ear-wrapper dark-toggle__ear-wrapper--6">
            <div class="dark-toggle__rabbit-ear-sub dark-toggle__rabbit-ear--6"></div>
          </div>
        </div>
        <div class="dark-toggle__part-wrapper dark-toggle__odd-ears-wrapper">
          <div class="dark-toggle__part-wrapper dark-toggle__ear-wrapper dark-toggle__ear-wrapper--1">
            <div class="dark-toggle__rabbit-ear dark-toggle__rabbit-ear--1"></div>
          </div>
          <div class="dark-toggle__part-wrapper dark-toggle__ear-wrapper dark-toggle__ear-wrapper--3">
            <div class="dark-toggle__rabbit-ear-sub dark-toggle__rabbit-ear--3"></div>
          </div>
          <div class="dark-toggle__part-wrapper dark-toggle__ear-wrapper dark-toggle__ear-wrapper--5">
            <div class="dark-toggle__rabbit-ear-sub dark-toggle__rabbit-ear--5"></div>
          </div>
          <div class="dark-toggle__part-wrapper dark-toggle__ear-wrapper dark-toggle__ear-wrapper--7">
            <div class="dark-toggle__rabbit-ear-sub dark-toggle__rabbit-ear--7"></div>
          </div>
        </div>
      </div>
      <div class="dark-toggle__part-wrapper dark-toggle__chest-wrapper">
        <div class="dark-toggle__rabbit-chest"></div>
      </div>
      <div class="dark-toggle__part-wrapper dark-toggle__body-wrapper">
        <div class="dark-toggle__rabbit-body"></div>
      </div>
      <div class="dark-toggle__part-wrapper dark-toggle__hind-leg-wrapper">
        <div class="dark-toggle__rabbit-hind-leg"></div>
      </div>
      <div class="dark-toggle__part-wrapper dark-toggle__tail-wrapper">
        <div class="dark-toggle__rabbit-tail"></div>
      </div>
      <div class="dark-toggle__part-wrapper dark-toggle__fore-paw-wrapper">
        <div class="dark-toggle__rabbit-fore-paw"></div>
        <div class="dark-toggle__rabbit-club"></div>
        <div class="dark-toggle__rabbit-club-lower"></div>
      </div>
      <div class="dark-toggle__part-wrapper dark-toggle__mortar-wrapper">
        <div class="dark-toggle__rabbit-mortar"></div>
      </div>
      <div class="dark-toggle__part-wrapper dark-toggle__head-wrapper">
        <div class="dark-toggle__rabbit-head">
          <div class="dark-toggle__rabbit-eye"></div>
        </div>
      </div>
    </div>
  </button>
`;
